if (ga) {
    var Config = require('./config/Config');
    ga('create', Config.analyticsProperty, 'auto');

    if (window.performance) {
        ga('send', 'timing', 'load', 'Loading Javascript',
            window.performance.timing.loadEventEnd - window.performance.timing.navigationStart, 'Bundle');
    }
}



// WEBPACK FOOTER //
// ./app/analytics.js